import React from 'react';
import PropTypes from 'prop-types';

import Fab from '@material-ui/core/Fab';
import PhoneIcon from '@material-ui/icons/Phone';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class CallButton extends React.Component {
  render() {
    const { classes, phoneNumber } = this.props;

    return (
      <div className={classes.root}>
        <Fab
          color='primary'
          component='a'
          href={'tel:' + phoneNumber}
          id='call-button'
          className={classes.callButton}
          aria-label={getString('dash', 'CALL_US_LABEL')}
        >
          <PhoneIcon className={classes.phoneIcon} />
        </Fab>
      </div>
    );
  }
}

CallButton.propTypes = {
  classes: PropTypes.object.isRequired,
  phoneNumber: PropTypes.string.isRequired,
};

CallButton.defaultProps = {};

export default withStyles(styles)(CallButton);
